import { Shield, LogIn } from "lucide-react";

export function LoginPage() {
  const handleLogin = () => {
    // Cloudflare Access will intercept and show login
    // Just reload the page — Access handles the rest
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-8 text-center">
        {/* Logo */}
        <div className="space-y-4">
          <img src="/logo.jpeg" alt="YSR" className="mx-auto h-16 w-16 rounded-2xl object-cover shadow-lg" />
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-foreground">
              YSR Admin Panel
            </h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Yönetim paneline erişmek için giriş yapın
            </p>
          </div>
        </div>

        {/* Login Card */}
        <div className="rounded-2xl border border-border/40 bg-card p-6 space-y-6">
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">
              Bu panel sadece yetkili kullanıcılara açıktır.
              Giriş için kurumsal e-posta adresinizi kullanın.
            </p>
          </div>

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-2 rounded-xl bg-accent px-4 py-3 text-sm font-medium text-accent-foreground transition-all hover:bg-accent/90 cursor-pointer"
          >
            <LogIn className="size-4" />
            Google ile Giriş Yap
          </button>

          <p className="text-xs text-muted-foreground">
            Cloudflare Zero Trust ile korunmaktadır
          </p>
        </div>

        {/* Footer */}
        <p className="text-xs text-muted-foreground/50">
          YSR Danışmanlık &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
